document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    
    // Video banner animation
    const videoBannerDesktop = document.querySelector('.video-banner_video.desktop');
    if (videoBannerDesktop) {
        const video = videoBannerDesktop.querySelector('video');
        const endPoint = window.innerHeight + videoBannerDesktop.offsetHeight;
        let videoTl = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".video-banner_video.desktop",
                    start: 'top top',
                    end: () => `+=${endPoint}`,
                    pin: true,
                    scrub: true,
                    invalidateOnRefresh: true
                },
        });
        videoTl.fromTo(
            video,
            {
                currentTime: 1,
            },
            {
                currentTime: 7,
            }
        );
    }
    
    // Image text overlay content animation
    const imageTextOverlayContents = document.querySelectorAll('.image-text-overlay-content');
    if (imageTextOverlayContents.length > 0) {
        imageTextOverlayContents.forEach(function(element) {
            const triggerPoint = element.querySelector('.image-text-overlay-wrapper');
            const imageTextIcon = element.querySelector('img');
            const imageTextTitle = element.querySelector('h2');
            const imageTextSubTitle = element.querySelector('h3');
            const imageTextContent = element.querySelector('.rte');
            const imageTextList = element.querySelectorAll('.list-item');
            const imageTextBlock = element.querySelectorAll('.block');
            let endPoint = 'top top +=100';
            
            if (imageTextList.length > 0) {
                endPoint = 'top top';
            }
            if (imageTextBlock.length > 0) {
                endPoint = 'top top';
            }
            
            let imageTextTl = gsap.timeline({
                    defaults: { duration: 1 },
                    scrollTrigger: {
                        trigger: triggerPoint,
                        start: 'top 70%',
                        end: endPoint,
                        pin: false,
                        scrub: true,
                        once: true,
                        invalidateOnRefresh: true
                    },
            });
            
            if (imageTextIcon) {
            imageTextTl.fromTo(
                imageTextIcon,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (imageTextTitle) {
            imageTextTl.fromTo(
                imageTextTitle,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (imageTextSubTitle) {
            imageTextTl.fromTo(
                imageTextSubTitle,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (imageTextContent) {
            imageTextTl.fromTo(
                imageTextContent,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (imageTextList.length > 0) {
                imageTextTl.fromTo(
                    imageTextList,
                    {
                        opacity: 0,
                        stagger: 0.5
                    },
                    {
                        opacity: 1,
                        stagger: 0.5
                    }
                );
            }
            
            if (imageTextBlock.length > 0) {
                imageTextTl.fromTo(
                    imageTextBlock,
                    {
                        opacity: 0,
                        stagger: 0.5
                    },
                    {
                        opacity: 1,
                        stagger: 0.5
                    }
                );
            }
        });
    }

    // Tilo details block animation
    const tiloDetailsBlocks = document.querySelectorAll('.tilo-details-block');
    if (tiloDetailsBlocks.length > 0) {
        tiloDetailsBlocks.forEach(function(element) {
            const tiloDetailsTitle = element.querySelector('h2');
            const tiloDetailsSubtitle = element.querySelector('h3');
            const tiloDetailsDots = element.querySelector('.dots-line');
            const tiloDetailsFeatures = element.querySelectorAll('.tilo-details-feature');
            const tiloDetailsButton = element.querySelector('.tilo-details-btn');
            
            let tiloDetailsTl = gsap.timeline({
                    defaults: { duration: 1 },
                    scrollTrigger: {
                    trigger: element,
                        start: 'top center',
                        end: 'top top +=100',
                        once: true,
                        pin: false,
                        scrub: true,
                        invalidateOnRefresh: true
                    },
            });
            
            if (tiloDetailsTitle) {
            tiloDetailsTl.fromTo(
                tiloDetailsTitle,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }

            if (tiloDetailsDots) {
            tiloDetailsTl.to(
                tiloDetailsDots, {
                    "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"
                }
            );
            }
            
            if (tiloDetailsSubtitle) {
            tiloDetailsTl.fromTo(
                tiloDetailsSubtitle,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (tiloDetailsFeatures.length > 0) {
                tiloDetailsTl.fromTo(
                    tiloDetailsFeatures,
                    {
                        opacity: 0,
                        stagger: 0.5
                    },
                    {
                        opacity: 1,
                        stagger: 0.5
                    }
                );
            }
            
            if (tiloDetailsButton) {
                tiloDetailsTl.fromTo(
                    tiloDetailsButton,
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1
                    }
                );
            }
        });
    }

    // Testimonial v2 wrapper animation
    const testimonialV2Wrappers = document.querySelectorAll('.testimonial-v2-wrapper');
    if (testimonialV2Wrappers.length > 0) {
        testimonialV2Wrappers.forEach(function(element) {
            const testimonialV2Content = element.querySelector('.testimonial-content');
            const testimonialV2Title = element.querySelector('.testimonial-title');
            const testimonialV2Position = element.querySelector('.testimonial-position');
            
            let testimonialV2Tl = gsap.timeline({
                    defaults: { duration: 1 },
                    scrollTrigger: {
                    trigger: element,
                        start: 'top 70%',
                        end: 'center center',
                        once: true,
                        pin: false,
                        scrub: true,
                        invalidateOnRefresh: true
                    },
            });
            
            if (testimonialV2Content) {
            testimonialV2Tl.fromTo(
                testimonialV2Content,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (testimonialV2Title) {
            testimonialV2Tl.fromTo(
                testimonialV2Title,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
            
            if (testimonialV2Position) {
            testimonialV2Tl.fromTo(
                testimonialV2Position,
                {
                        opacity: 0
                },
                {
                        opacity: 1
                }
            );
            }
        });
    }
});
